import React from 'react';
import '../Estilos/HourPicker.css';
/**
 * @param titulo (string) Título mostrado no select.
 * @param itens (object) Lista de itens[{id:string,nome:string,status:boolean}].
 * @param padrao (string) Valor Padrão mostrado.
 * @param hasCheckBox (bool) Checkbox habilitado.
 * @param hideID (bool) Esconde ID no Select.
 * @param minValue (time) Define valor mínimo.
 * @param maxValue (time) Define valor máximo.
 * @function minValueChanged (hour) Atualiza status dos itens
 * @function maxValueChanged (hour) Atualiza status dos itens
 */
export default function HourPicker(props) {
  return (
    <div className="PickerView">
      <h3>{props.titulo}</h3>

      <div className="PickerHourView">
        <input
          type="time"
          value={props.minValue}
          min="00:00"
          max="23:58"
          onChange={(e) => {
            props.minValueChanged(e.target.value);
          }}
        />
        <p>~</p>

        <input
          type="time"
          value={props.maxValue}
          min="00:01"
          max="23:59"
          onChange={(e) => {
            props.maxValueChanged(e.target.value);
          }}
        />
      </div>
      {props.erro && props.erroTexto && (
        <div
          style={{
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingTop: 8,
          }}
        >
          <img src={require('../Icones/block.svg').default} alt="block" />
          <h4
            style={{
              color: 'red',
              fontSize: 12,
              padding: 0,
              margin: 0,
              verticalAlign: 'center',
              paddingLeft: 8,
              fontFamily: 'montserrat',
              fontWeight: 500,
            }}
          >
            {props.erroTexto}
          </h4>
        </div>
      )}
    </div>
  );
}
